import { render, staticRenderFns } from "./LiveloPointsRuleModal.vue?vue&type=template&id=2dd7c31d&scoped=true&"
import script from "./LiveloPointsRuleModal.vue?vue&type=script&lang=js&"
export * from "./LiveloPointsRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./LiveloPointsRuleModal.vue?vue&type=style&index=0&id=2dd7c31d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7c31d",
  null
  
)

export default component.exports